import styled from "styled-components";
import { useState } from "react";
import { serverLine } from "../../../controllers/network/serverLine";

const Container = styled.div`
  ${({ readOnly }) => {
    if (readOnly)
      return `
      opacity:0.9;
      pointer-events:none;

    `;
  }}
`;

const RadioCircle = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--border);
  background: ${({ $active, $danger }) =>
    $active
      ? $danger
        ? "var(--danger, #f54a00)"
        : "var(--success, #1ba94c)"
      : "transparent"};
  cursor: ${({ readOnly }) => (readOnly ? "default" : "pointer")};
  opacity: ${({ readOnly }) => (readOnly ? 0.6 : 1)};
  transition: all 0.15s ease;

  &:hover {
    filter: brightness(1.05);
  }
`;

export default function MarkAbsentOrNotCell({
  value,
  userID,
  date,
  updateRow,
  readOnly,
  target, // "PRS" | "ABS"
  isRestDay,
}) {
  const [saving, setSaving] = useState(false);
  const isAbsent = value === "OUI";
  const isPresent = value === "NON";
  const isActive = target === "ABS" ? isAbsent : isPresent;
  const setToAbsent = target === "ABS";
  const isDisabled = readOnly || isRestDay || saving;

  if (!userID) return "userID required";

  return (
    <Container readOnly={readOnly}>
      <RadioCircle
        onClick={() => {
          if (isDisabled) return;
          setNewVal(setToAbsent);
        }}
        $active={isActive}
        $danger={target === "ABS"}
        readOnly={isDisabled}
        aria-label={target === "ABS" ? "Absent" : "Présent"}
      />
    </Container>
  );

  function setVal(theNewVal) {
    //we are updating the row instead of storing the value in the cell itself
    //because cell can experience rerender of hoz scrolling
    let payload = null;
    if (theNewVal === true) payload = "OUI";
    else if (theNewVal === false) payload = "NON";
    updateRow({ userID, field: "Absence", value: payload });
  }

  async function setNewVal(newVal) {
    // Toggle behaviour: clicking the active radio deselects (null)
    let targetVal;
    if (setToAbsent) {
      targetVal = isAbsent ? null : true;
    } else {
      targetVal = isPresent ? null : false;
    }

    let status = null;
    if (targetVal === true) status = "ABSENT";
    if (targetVal === false) status = "PRESENT";

    try {
      setSaving(true);
      await serverLine.patch("/presence-status", {
        date,
        userID,
        status,
      });
      setVal(targetVal);
    } catch (e) {
      window.popupAlert?.(e.message || "Erreur de sauvegarde du pointage");
    } finally {
      setSaving(false);
    }
  }
}
